import { createTheme } from "@mui/material/styles";

/** Site vitrine Flash : thème sombre uniquement (pas de variante claire). */
const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#0F0F0F",
      paper: "#181818",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#85898F",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
